import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {SitesAlertsService} from "../../../sites/services/sites-alerts.service";
import {SitesRequestsService} from "../../../sites/services/sites-requests.service";
import {PreferencesDialogService} from "../../services/preferences-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class sitePlanViewCtrl implements IController {

  plan: any;

  private siteId: any;
  public modules: any;
  private flavors: any;
  private flavor: any;
  private updating: boolean;

  public programSubModules: any[];

  /* @ngInject */
  constructor(private $log, private $mdDialog, private bringozLoaderService: BringozLoaderService, private confirmDialogService: ConfirmDialogService,
              private IAMPermissions, private sitesAlertsService: SitesAlertsService, private splitService,
              private sitesRequestsService: SitesRequestsService, private preferencesDialogService: PreferencesDialogService) {}

  $onInit() {
    this.siteId = this.splitService.getSiteId();
    this.updating = false;
    this.modules = {};
    this.flavors = [{
            id:'lite',
            name:'Lite'
        }, {
            id:'base',
            name:'Base'
        }];

    this.flavor = this.plan.flavor;
    this.modules = _.keyBy(this.plan.modules, 'id');
    this._setSubModules(this.modules);
  }

  // ******************************
  //        Public methods
  // ******************************

  toggleModule(module, $event) {
    let loading = false;
    let moduleCopy;

    const title = module.enabled ? 'Disable module' : 'Enable module';
    const textContent = module.enabled ?
        'Would you like to disable ' + module.name + ' module?' :
        'Would you like to enable ' + module.name + ' module?';

    this.confirmDialogService.confirm(title, textContent, $event)
      .then(() => {
        loading = true;
        this.bringozLoaderService.on();

        //Prevent change on the models
        moduleCopy = angular.copy(module);
        moduleCopy.enabled = !module.enabled;

        return this.sitesRequestsService.updateSitePlanModule(this.siteId, moduleCopy);
      })
      .then((updatedModule) => {
        this.modules[updatedModule.id] = updatedModule;
        this.sitesAlertsService.updateModuleSuccess();
        this._setSubModules(this.modules);
        this._setPermissions(this.modules);
      })
      .catch((error) => {
        if (error) {
          this.sitesAlertsService.updateModuleError();
          this.$log.error('Update failed', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      });
  }

  changeFlavor(event) {
    this.preferencesDialogService.changeSiteFlavorDialog(event, this.flavors, this.flavor.id)
      .then((selectedFlavorId) => {
        this._updateFlavor(selectedFlavorId);
      })
      .catch((error) => {
        if (error) {
          this.$log.info(error);
        }
      })
      .finally(() => {
        this.$log.info('Dialog Closed');
      });
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setSubModules(modules) {
    this.programSubModules = [modules.priceplan];
  }

  _updateFlavor(selectedFlavorId) {
    this.bringozLoaderService.on();
    this.updating = true;
    this.sitesRequestsService.updateSiteFlavor(this.siteId, selectedFlavorId)
      .then((updatedFlavor) => {
        if(!updatedFlavor) return;

        this.flavor = updatedFlavor;
        this.sitesAlertsService.updateFlavorSuccess();
      })
      .catch(() => {
        this.sitesAlertsService.updateFlavorError();
        this.$log.error('Update failed');
      })
      .finally(() => {
        this.bringozLoaderService.off();
        this.updating = false;
      });
  }

  _setPermissions(modulesMap) {
    const modulesList = _.values(modulesMap);
    this.IAMPermissions.setSitePermissions(this.siteId, modulesList)
      .then((updatedPermissions) => {})
      .catch((error) => {
        this.$log.error('Failed to get/set new permissions @sitePlanView@_setPermissions', error);
      })
  }

}
angular
  .module('bringoz.admin.site-preferences')
  .component('sitePlanView', {
    bindings: {
      plan: '<'
    },
    template: require('./site-plan-view.html').default,
    controller: sitePlanViewCtrl
  });
